import { Typography, Button, Menu, MenuItem } from "@material-ui/core";
import axios from "axios";
import moment from "moment/moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { constants } from "../Helpers/constantsFile";
import { TextField } from "@mui/material";

const Tickets = () => {
  const [tickets, setTickets] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const [startDate, setStartDate] = useState(() => {
    const oneWeekAgo = moment().subtract(7, "days").toISOString().split("T")[0];
    return oneWeekAgo;
  });
  const [endDate, setEndDate] = useState(new Date().toISOString().split("T")[0]);

  const token = useSelector((state) => state.token.token);

  const readTickets = () => {
    axios
      .get(
        `${constants.baseUrl}/support-tickets?startDate=${moment(startDate).format(
          "YYYY-MM-DD"
        )}&endDate=${moment(endDate).format("YYYY-MM-DD")}`,
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res?.data)
        const sorted = res?.data?.data?.tickets.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );
        setTickets(sorted);
      })
      .catch((err) => {
        console.log(err);
        alert(err.response?.data?.message);
      });
  };

  useEffect(() => {
    readTickets();
  }, [startDate, endDate]);

  const handleMenuOpen = (event, ticket) => {
    setAnchorEl(event.currentTarget);
    setSelectedTicket(ticket);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedTicket(null);
  };

  const handleStatusChange = (status) => {
    axios
      .patch(
        `${constants.baseUrl}/support-tickets/${selectedTicket.id}`,
        { status },
        { headers: { authorization: token } }
      )
      .then(() => {
        setTickets(
          tickets.map((t) =>
            t.id === selectedTicket.id ? { ...t, status } : t
          )
        );
        handleMenuClose();
      })
      .catch((err) => {
        console.log(err);
        alert(err.response?.data?.message);
      });
  };

  return (
    <div style={{ width: "93%", margin: "20px auto" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography style={{ fontSize: "22px", fontWeight: "bold" }}>
          Support Tickets
        </Typography>

        <div style={{ marginBottom: "20px" }}>
          <TextField
            size="small"
            variant="outlined"
            type="date"
            label="Start Date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            style={{ marginRight: "20px" }}
          />

          <TextField
            size="small"
            variant="outlined"
            type="date"
            label="End Date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            style={{ marginRight: "20px" }}
          />
        </div>
      </div>

      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "12px" }}>
        {tickets?.map((t, index) => (
          <div
            key={t.id}
            style={{
              display: "flex",
              cursor: "pointer",
              flexDirection: "row",
              background: "white",
              padding: "15px",
              alignItems: "center",
              borderRadius: "10px",
            }}
          >
            <Typography style={{ fontSize: "16px", flex: 0.2, color: "grey" }}>
              {index + 1}.
            </Typography>

            {/* Ticket Title */}
            <Typography style={{ fontSize: "16px", flex: 2 }}>
              {t?.user ? t.user?.name : "Unknown User"}
            </Typography>

            {/* Phone */}
            <Typography style={{ fontSize: "16px", flex: 1 }}>
              {t?.phone}
            </Typography>

            {/* Description or placeholder */}
            <Typography style={{ fontSize: "16px", flex: 3  }}>
              {t?.details}
            </Typography>
            <Typography style={{ fontSize: "16px", flex: 1 , fontWeight: "bold" }}>
              {t?.category}
            </Typography>

            {/* Created Date */}
            <Typography style={{ fontSize: "16px", flex: 1}}>
              {moment(t?.created_at).format("YYYY-MM-DD")}
            </Typography>

            {/* Status */}
            <Typography
              style={{
                fontSize: "16px",
                flex: 1,
                color:
                  t?.status === "resolved"
                    ? "green"
                    : t?.status === "in_progress"
                    ? "blue"
                    : t?.status === "open"
                    ? "orange"
                    : null,
              }}
            >
              {t?.status}
            </Typography>

            <Button variant="contained" onClick={(e) => handleMenuOpen(e, t)}>
              Set Status
            </Button>

            <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose}>
              {["open", "in_progress", "resolved"].map((status) => (
                <MenuItem key={status} onClick={() => handleStatusChange(status)}>
                  {status}
                </MenuItem>
              ))}
            </Menu>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tickets;
